export default __webpack_public_path__ + "static/media/process.fbc260e4.png";